import { WineSalesMode } from '@/shared/api';
import type { UiLanguage } from '@/shared/lib';
import type { MarketConfig } from '../api/marketConfig';

/**
 * Ветвление по параметрам рынка, а не по коду рынка (ARCH-01, docs/frontend/deltas.md).
 */

/** Вино продаёт партнёр (RU: ТБН) — в меню «Партнёры по вину», а не «Доставки». */
export function sellsWineViaPartner(config: MarketConfig): boolean {
  return config.commerce.wine_sales_mode === WineSalesMode.Partner;
}

/** Переключатель языка показывается, только если языков интерфейса больше одного (World: EN/ES). */
export function hasLanguageChoice(config: MarketConfig): boolean {
  return config.languages.length > 1;
}

/** Язык интерфейса, допустимый на рынке: выбранный пользователем или язык рынка по умолчанию. */
export function resolveMarketLanguage(config: MarketConfig, preferred: UiLanguage): UiLanguage {
  return config.languages.includes(preferred) ? preferred : config.default_language;
}
